var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundLanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1858,
    height: 261,
    viewBox: "0 0 1858 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 70C0 31.3401 31.3401 0 70 0H1858V261H0V70Z",
    fill: "#132F60"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 193.375,
    y: 158.376,
    width: 28,
    height: 28,
    rx: 2.5,
    transform: "rotate(-30 193.375 158.376)",
    stroke: "#18A0FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 538.683,
    y: 126.683,
    width: 28,
    height: 28,
    rx: 2.5,
    transform: "rotate(-30 538.683 126.683)",
    stroke: "#18A0FB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 68.683,
    y: 146.683,
    width: 28,
    height: 28,
    rx: 2.5,
    transform: "rotate(-30 68.683 146.683)",
    stroke: "#18A0FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 356.782,
    y: 208.515,
    width: 17.8026,
    height: 17.8026,
    rx: 2.5,
    transform: "rotate(-30 356.782 208.515)",
    stroke: "#18A0FB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 315.683,
    y: 125.583,
    width: 17.8026,
    height: 17.8026,
    rx: 2.5,
    transform: "rotate(-30 315.683 125.583)",
    stroke: "#18A0FB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 848.375,
    y: 126.376,
    width: 28,
    height: 28,
    rx: 2.5,
    transform: "rotate(-30 848.375 126.376)",
    stroke: "#18A0FB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 1193.68,
    y: 94.683,
    width: 28,
    height: 28,
    rx: 2.5,
    transform: "rotate(-30 1193.68 94.683)",
    stroke: "#18A0FB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 723.683,
    y: 114.683,
    width: 28,
    height: 28,
    rx: 2.5,
    transform: "rotate(-30 723.683 114.683)",
    stroke: "#18A0FB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 1011.78,
    y: 176.515,
    width: 17.8026,
    height: 17.8026,
    rx: 2.5,
    transform: "rotate(-30 1011.78 176.515)",
    stroke: "#18A0FB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 970.683,
    y: 93.5834,
    width: 17.8026,
    height: 17.8026,
    rx: 2.5,
    transform: "rotate(-30 970.683 93.5834)",
    stroke: "#18A0FB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 553.375,
    y: 70.3764,
    width: 28,
    height: 28,
    rx: 2.5,
    transform: "rotate(-30 553.375 70.3764)",
    stroke: "#18A0FB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 898.683,
    y: 38.683,
    width: 28,
    height: 28,
    rx: 2.5,
    transform: "rotate(-30 898.683 38.683)",
    stroke: "#18A0FB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 428.683,
    y: 58.683,
    width: 28,
    height: 28,
    rx: 2.5,
    transform: "rotate(-30 428.683 58.683)",
    stroke: "#18A0FB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 716.782,
    y: 120.515,
    width: 17.8026,
    height: 17.8026,
    rx: 2.5,
    transform: "rotate(-30 716.782 120.515)",
    stroke: "#18A0FB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 675.683,
    y: 37.5834,
    width: 17.8026,
    height: 17.8026,
    rx: 2.5,
    transform: "rotate(-30 675.683 37.5834)",
    stroke: "#18A0FB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.671099,
    y: 0.179696,
    width: 51.4937,
    height: 52.555,
    rx: 2.5,
    transform: "matrix(0.857137 -0.515088 0.485062 0.87448 260.401 91.5074)",
    stroke: "#18A0FB"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.671099,
    y: 0.179696,
    width: 51.4937,
    height: 52.555,
    rx: 2.5,
    transform: "matrix(0.857137 -0.515088 0.485062 0.87448 879.037 32.4071)",
    stroke: "#18A0FB"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.671099,
    y: 0.179696,
    width: 51.4937,
    height: 52.555,
    rx: 2.5,
    transform: "matrix(0.857137 -0.515088 0.485062 0.87448 37.0087 69.7022)",
    stroke: "#18A0FB"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.671099,
    y: 0.179696,
    width: 33.035,
    height: 33.7231,
    rx: 2.5,
    transform: "matrix(0.857137 -0.515088 0.485062 0.87448 553.152 185.004)",
    stroke: "#18A0FB"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.671099,
    y: 0.179696,
    width: 33.035,
    height: 33.7231,
    rx: 2.5,
    transform: "matrix(0.857137 -0.515088 0.485062 0.87448 479.521 30.3566)",
    stroke: "#18A0FB"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.671099,
    y: 0.179696,
    width: 51.4937,
    height: 52.555,
    rx: 2.5,
    transform: "matrix(0.857137 -0.515088 0.485062 0.87448 1403.4 110.507)",
    stroke: "#18A0FB"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.671099,
    y: 0.179696,
    width: 51.4937,
    height: 52.555,
    rx: 2.5,
    transform: "matrix(0.857137 -0.515088 0.485062 0.87448 1180.01 88.7022)",
    stroke: "#18A0FB"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.671099,
    y: 0.179696,
    width: 33.035,
    height: 33.7231,
    rx: 2.5,
    transform: "matrix(0.857137 -0.515088 0.485062 0.87448 1696.15 204.004)",
    stroke: "#18A0FB"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.671099,
    y: 0.179696,
    width: 33.035,
    height: 33.7231,
    rx: 2.5,
    transform: "matrix(0.857137 -0.515088 0.485062 0.87448 1622.52 49.3566)",
    stroke: "#18A0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLanding);
export default __webpack_public_path__ + "static/media/background_landing.eccde4342081bdbab7681a162e6bdb45.svg";
export { ForwardRef as ReactComponent };